// extracted by mini-css-extract-plugin
export default {"products":"IB-z","card":"JB-z","oosMessaging":"KB-z"};